import { render, staticRenderFns } from "./Supplier_total.vue?vue&type=template&id=4c958889&scoped=true&"
import script from "./Supplier_total.vue?vue&type=script&lang=js&"
export * from "./Supplier_total.vue?vue&type=script&lang=js&"
import style0 from "./Supplier_total.vue?vue&type=style&index=0&id=4c958889&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c958889",
  null
  
)

export default component.exports